const rankingData = [
  { rank: 1, title: '极限追凶', category: '动作片', score: '9.5', trend: 'up', desc: '高智商警匪对决，全程无尿点' },
  { rank: 2, title: '欢乐喜剧人', category: '喜剧片', score: '9.3', trend: 'up', desc: '笑点密集，合家欢首选' },
  { rank: 3, title: '星际迷航：新纪元', category: '科幻片', score: '9.2', trend: 'up', desc: '视觉震撼，年度科幻巨制' },
  { rank: 4, title: '密室逃脱', category: '悬疑片', score: '9.0', trend: 'new', desc: '烧脑剧情，反转不断' },
  { rank: 5, title: '青春不散场', category: '爱情片', score: '8.8', trend: 'up', desc: '温暖治愈，唤起青春记忆' },
  { rank: 6, title: '暗夜行者', category: '动作片', score: '8.7', trend: 'up', desc: '暗黑风格动作大片' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-fire-line text-2xl text-accent-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
            热播排行榜
          </h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10 ml-11">
          悟空影视最新电影热度排行，实时更新观影趋势
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-500/30 transition-all duration-200 cursor-pointer group"
            >
              <div className="relative w-12 h-12 flex-shrink-0 flex items-center justify-center">
                <span className={`font-heading text-2xl font-bold ${
                  item.rank === 1 ? 'text-accent-500' :
                  item.rank === 2 ? 'text-accent-400' :
                  item.rank === 3 ? 'text-primary-400' :
                  'text-secondary-400'
                }`}>
                  {item.rank.toString().padStart(2, '0')}
                </span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors truncate">
                    {item.title}
                  </h3>
                  {item.trend === 'new' && (
                    <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] font-semibold rounded bg-accent-500/20 text-accent-400 whitespace-nowrap">NEW</span>
                  )}
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span>{item.category}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-600"></span>
                  <span>{item.desc}</span>
                </div>
              </div>

              <div className="flex-shrink-0 text-right">
                <span className="text-sm font-bold text-primary-400">{item.score}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}